<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="mianbao">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/shop' }">商城</el-breadcrumb-item>
          <el-breadcrumb-item>购物车</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="shoop-body">
        <div class="shop-title">
          <div class="name">商品信息</div>
          <div class="price">
            <div class="number">
              合计金额：<span class="price-num">￥{{ allPrice || "0.00" }}</span>
            </div>
            <gradient-button background="#387DF6" @hit="handleSettlement">去结算</gradient-button>
          </div>
        </div>
        <div class="goods-innre" v-loading="loading">
          <el-empty v-if="carList.length === 0" description="暂无商品"/>
          <el-table v-else :data="carList" :header-cell-style="{
            backgroundColor: '#F6F6F8',
            textAlign: 'center',
          }" :cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange" border>
            <el-table-column type="selection" width="55"/>
            <el-table-column prop="cas_no" label="CAS" width="100"></el-table-column>
            <el-table-column prop="product_name" label="商品名称" width="180"/>
            <el-table-column label="商品图片" width="150">
              <template slot-scope="scope">
                <img v-if="scope.row.product" :src="scope.row.product.image" alt="商品图片" class="goods-img"/>
              </template>
            </el-table-column>
            <el-table-column prop="sku" label="规格"/>
            <el-table-column prop="price" label="单价">
              <template slot-scope="scope" v-if="scope.row.product">
                <span>{{ isVip ? scope.row.product.baojia_price : scope.row.product.price || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="数量" width="210">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.cart_num" :min="1" :max="100" @change="handleChange(scope.row)"/>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="小计" width="120">
              <template slot-scope="scope" v-if="scope.row.product">
                <span class="price-num" v-if="isVip">{{
                    (scope.row.product.baojia_price * scope.row.cart_num).toFixed(2)
                  }}元</span>
                <span class="price-num" v-else>{{ (scope.row.product.price * scope.row.cart_num).toFixed(2) }}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page-box">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                           :current-page="page" @current-change="handleCurrentChange"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import {shop_cart_list, shop_cart_delete} from "@/api/modules/home";
import gradientButton from "@/components/button/gradient-button.vue";
import {changeNum} from "@/api/modules/user";
import HomeFooter from "@/components/public/home-footer.vue";

export default {
  name: "car",
  components: {
    HomeFooter,
    homeTop,
    gradientButton,
  },
  data() {
    return {
      carList: [],
      loading: false,
      total: 0,
      page: 1,
      pageSize: 10,
      selectedList: [],
    };
  },
  computed: {
    isVip() {
      return this.$store.getters.is_vip;
    },
    allPrice() {
      const total = this.selectedList.reduce(
          (total, item) => {
            if (this.isVip) {
              if (item.product) {
                return total + Number(item.product.baojia_price) * Number(item.cart_num);
              }else{
                return total;
              }
            } else {
              return total + Number(item.product.price) * Number(item.cart_num);
            }
          },
          0
      );
      return total.toFixed(2);
    },
  },
  created() {
    this.getCarList();
  },
  methods: {
    // 多选
    handleSelectionChange(val) {
      this.selectedList = val;
    },
    // 分页
    handleCurrentChange(page) {
      this.page = page;
      this.getCarList();
    },
    // 去结算
    handleSettlement() {
      if (this.selectedList.length === 0) {
        this.$message.warning({
          message: "请选择商品",
          type: "warning",
          duration: 2000,
          offset: 300,
        });
        return;
      }
      let data = this.selectedList.map((item) => {
        return {
          product_name: item.product.product_name,
          cas_no: item.product.cas_no,
          sku: item.sku,
          weight: item.sku.split(',')[0],
          purity:item.sku.split(',')[1],
          custorm_price: this.isVip ? item.product.baojia_price : item.product.price,
          supply_id: item.shop_user_id,
          num: item.cart_num,
          id: item.id
        };
      });
      // 将data存储到vuex中
      this.$store.commit("SET_SETTLEMENT_LIST", data);
      // 跳转结算页面
      this.$router.push({
        path: "/shop/settlement",
      });
    },
    // 获取购物车列表
    getCarList() {
      this.loading = true;
      shop_cart_list({
        page: this.page,
        limit: this.pageSize,
      }).then((res) => {
        this.carList = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 数量改变
    handleChange(row) {
      changeNum(row.id, {cart_num: row.cart_num}).then((res) => {
        if (res.data.code == 10000) {
          // this.$message.success({
          //   message: "修改成功",
          //   type: "success",
          //   duration: 2000,
          //   offset: 300,
          // });
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            duration: 2000,
            offset: 300,
          });
        }
      });
    },
    // 删除购物车商品
    handleDelete(row) {
      this.$confirm("确定删除该商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shop_cart_delete(row.id).then((res) => {
          if (res.data.code === 10000) {
            this.$message.success({
              message: "删除成功",
              type: "success",
              duration: 2000,
              offset: 300,
            });
            this.getCarList();
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              duration: 2000,
              offset: 300,
            });
          }
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.h-top {
  // height: 142px;
  height: 120px;
}

.content {
  .mianbao {
    margin-top: 20px;
  }

  .shoop-body {
    margin-top: 30px;
    padding: 20px 60px;
    background: #ffffff;
    margin-bottom: 100px;

    .shop-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .name {
        font-size: 20px;
        font-weight: 600;
        color: #00112b;
      }

      .price {
        display: flex;
        align-items: end;

        .number {
          font-weight: 400;
          font-size: 18px;
          color: #5f616c;
          margin-right: 20px;

          .price-num {
            color: #ff4400;
          }
        }
      }
    }

    .goods-innre {
      margin-top: 40px;
      min-height: 500px;

      .goods-img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      .price-num {
        color: #ff4400;
      }
    }

    .page-box {
      margin-top: 40px;
      text-align: right;
    }
  }
}
</style>
